/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Kantor_S2Inputs */

const en_tut_kantor_s2 = /** @type {(inputs: Tut_Kantor_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press **Masuk kantor**. Pick a character and colours in the **Ubah avatar** dialog and save — your avatar appears in the lobby.`)
};

const id_tut_kantor_s2 = /** @type {(inputs: Tut_Kantor_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekan **Masuk kantor**. Pilih karakter dan warna pada dialog **Ubah avatar**, lalu simpan — avatar Anda muncul di lobi.`)
};

/**
* | output |
* | --- |
* | "Press **Masuk kantor**. Pick a character and colours in the **Ubah avatar** dialog and save — your avatar appears in the lobby." |
*
* @param {Tut_Kantor_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_kantor_s2 = /** @type {((inputs?: Tut_Kantor_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Kantor_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_kantor_s2(inputs)
	return en_tut_kantor_s2(inputs)
});